import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=115ba034&scoped=true&%23loading=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ba034",
  null
  
)

export default component.exports